import StageCard from "./stage-card";
import EventSurvey from "./event-survey";
import { isStageAvailable } from "../../utils/event";
import { getTranslatedField } from "../../utils/lang";

const StageDetail = ({
  stage,
  appLang,
  labels,
  register,
  errors,
  touchedFields,
  dirtyFields,
  trigger,
  formWatch,
  control,
  eventId,
  createRequest,
  updateRequest,
  reservation,
  handleSubmit,
  isLoading,
  isError,
}) => {
  const onSubmit = async (values) => {
    if (reservation?.id) {
      await updateRequest({
        eventId,
        formData: { ...values, stage: stage?.id },
        stage,
      });
    } else {
      await createRequest({
        eventId,
        formData: { ...values, stage: stage?.id },
        stage,
      });
    }
  };

  return (
    <div className="wrapper wrapper-small">
      <form onSubmit={handleSubmit(onSubmit)} className="event__detail" noValidate>
        <StageCard stage={stage} appLang={appLang} labels={labels} />
        <EventSurvey
          stage={stage}
          errors={errors}
          touchedFields={touchedFields}
          dirtyFields={dirtyFields}
          control={control}
          trigger={trigger}
          labels={labels}
          locale={appLang?.value}
          formWatch={formWatch}
          appLang={appLang}
          register={register}
          visible={true}
        />
        {isError && <div className="error text-center">An error occurred saving your request</div>}
        <div className="form__buttons form__buttons--center">
          <button className="button primary">
            {isLoading && <span className="loading-spinner" />}
            {isStageAvailable(stage)
              ? labels?.EVENT_BOOK_EVENT || "Book event"
              : labels?.EVENT_SIGN_UP_WAITING_LIST || "Sign up to the waiting list"}
          </button>
        </div>
        {stage?.availableSeats === 0 && (
          <div
            className="event__text"
            dangerouslySetInnerHTML={{
              __html:
                labels?.EVENT_DETAIL_WAITING_LIST_DESCRIPTION ||
                "If you sign up to the waiting list, you will receive an email <strong>if there will be any available seats.</strong>",
            }}
          />
        )}
      </form>
      <div
        className="event__text"
        dangerouslySetInnerHTML={{ __html: getTranslatedField(stage, appLang, "description") }}
      />
    </div>
  );
};

export default StageDetail;
